<template>
  <vs-row vs-justify="center">
    <vs-col type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="12"
            vs-xs="12">
      <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
      <!-- Inicio Panel FILTRO -->
      <vs-card style="border-radius: 1.5em;">
        <div slot="header">
          <h3 class="card-title mb-0">Información de filtro</h3>
        </div>
        <vs-row>
          <vs-col vs-lg="6"
                  vs-xs="12"
                  vs-sm="12">
            <!-- Selector de empresa -->
            <company-selector v-model="companyId"/>
          </vs-col>
          <vs-col vs-lg="6"
                  vs-xs="12"
                  vs-sm="12">
            <label class="vs-input--label">Tipo de plantilla</label>
            <multiselect v-model="selectedTemplate"
                         placeholder="Seleccione una plantilla"
                         label="nickName"
                         track-by="id"
                         :options="templates"
                         :multiple="false"
                         :taggable="true"
                         :max-height="150"
                         :max="50">
            </multiselect>
          </vs-col>
        </vs-row>
        <br>
        <vs-row>
          <vs-col vs-lg="6" vs-xs="12" vs-sm="12">
            <label class="vs-input--label">Fecha inicial</label>
            <vs-input type="date" v-model="initialDate" class="w-100 "/>
          </vs-col>
          <vs-col vs-lg="6" vs-xs="12" vs-sm="12">
            <label class="vs-input--label">Fecha final</label>
            <vs-input type="date" v-model="finalDate" class="w-100 "/>
          </vs-col>
        </vs-row>
        <hr class="custom-hr"/>
        <div class="d-inline-block d-md-flex align-items-center">
          <div class="btn-alignment">
            <vs-button color="gray"
                       @click="clearForm()">Limpiar
            </vs-button>
          </div>
          <div class="ml-auto mt-3 mt-md-0">
            <div class="d-flex align-items-center">
              <div class="d-flex align-items-center dropdownbtn-alignment ml-3">
                <vs-button class="btnx"
                           type="filled"
                           color="danger"
                           @click="downloadContaiReport()">
                  <i class="ti-upload mr-2"></i>Exportar
                </vs-button>

                <vs-dropdown>
                  <vs-button class="btn-drop" type="filled" color="danger" icon="expand_more"></vs-button>
                  <vs-dropdown-menu>
                    <vs-button class="dropdown-item" color="'default'" v-for="document in documents"
                               :value="document.id" :key="document.id"
                               :id="document.id" @click="formatType=document.id">{{ document.name }}
                    </vs-button>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>
          </div>
        </div>
      </vs-card>

    </vs-col>
  </vs-row>
</template>
<script>
import CompanySelector from "@/components/Shared/CompanySelector/index.vue";
import multiselect from "vue-multiselect";
import DateUtils, {FORMATS} from "@/global/DateUtils";
import toast from "@/global/ToastConfig";
import {reportNames} from "@/global/constants";
import integrationsReportsEndPoints from "@/endpoints/reports/integrations-reports/IntegrationsReportsEndPoints";

export default {
  components: {multiselect, CompanySelector},
  data() {
    return {
      isLoading: false,
      companyId: null,
      initialDate: null,
      finalDate: null,
      templates: [
        {id: 1, nickName: "1 -Importación de movimiento"},
        {id: 2, nickName: "2 -Importación de nits"}
      ],
      selectedTemplate: null,
      documents: [
        {name: ".txt", id: "txt"},
      ],
      rangeMax: 31
    }
  },
  watch: {},
  methods: {
    /**
     * Método para sumar dias a una fecha parametro
     * @param finalDate
     * @returns {*|string}
     */
    addDateDays(finalDate) {
      const newDate = DateUtils.addDays({
        date: finalDate, amount: 1
      });
      return DateUtils.parseForced({date: newDate, format: FORMATS.DATE_SHORT});
    },
    /**
     *
     */
    clearForm() {
      this.companyId = null;
      this.initialDate = null;
      this.finalDate = null;
      this.selectedTemplate = null;
    },
    /**
     * valida los parametros de búsqueda
     */
    validateForm() {
      if (!this.finalDate || !this.initialDate) {
        throw new Error("Debe seleccionar la fecha inicial y/o la fecha final");
      }
      const validDates = DateUtils.isBefore({
        before: this.finalDate,
        date: this.initialDate,
      });
      if (validDates) {
        throw new Error("La fecha final no puede ser inferior a la fecha inicial");
      }
      const rangeSearch = DateUtils.differenceInDays(
          this.initialDate, this.finalDate
      )
      if (rangeSearch > this.rangeMax) {
        throw new Error("El rango de fechas supera el máximo permitido. Máximo de dias " + this.rangeMax);
      }
      if (!this.companyId) {
        throw new Error("Seleccione una compañía");
      }
      if (!this.selectedTemplate) {
        throw new Error("El tipo de plantilla es requerido");
      }
    },

    /**
     * lista los parametros de búsqueda
     * @returns {{finalDate: string, companyId: null, initialDate: string}}
     */
    prepareParameters() {
      return {
        companyId: this.companyId,
        initialDate: DateUtils.toDateShortString({
          date: this.initialDate,
        }),
        finalDate: this.addDateDays(this.finalDate),
      }
    },
    downloadContaiReport() {
      try {
        this.validateForm();
        const params = this.prepareParameters();
        this.selectedTemplate.id === 1 ? this.downloadMovements(params) : this.downloadNits(params);
      } catch (error) {
        toast.error(error.toString());
      }

    },
    downloadMovements(params) {
      try {
        this.isLoading = true;
        this.validateForm();
        toast.info("Cargando el  archivo, por favor, espere");
        const fileName = reportNames.INTEGRATIONS.CONTAI_MOVEMET.title
        integrationsReportsEndPoints.downloadContaiMovementReport(params, fileName)
            .then(response => {
              toast.ok("Archivo descargado exitosamente")
              this.isLoading = false;
            }).catch(error => {
          toast.error("Error al descargar el archivo")
          this.isLoading = false;
        });
      } catch (error) {
        toast.error(error.toString())
        this.isLoading = false;
      }
    },
    downloadNits(params) {
      try {
        this.isLoading = true;
        this.validateForm();
        toast.info("Cargando el  archivo, por favor, espere");
        const fileName = reportNames.INTEGRATIONS.CONTAI_NITS.title;
        integrationsReportsEndPoints.downloadContaiNitsReport(params, fileName)
            .then(response => {
              toast.ok("Archivo descargado exitosamente")
              this.isLoading = false;
            }).catch(error => {
          toast.error("Error al descargar el archivo")
          this.isLoading = false;
        });
      } catch (error) {
        toast.error(error.toString())
        this.isLoading = false;
      }
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"/>